import { render, staticRenderFns } from "./ItemRentSection.vue?vue&type=template&id=284c712c&"
import script from "./ItemRentSection.vue?vue&type=script&lang=js&"
export * from "./ItemRentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports